import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HangerLandingSequence, UpdateWellheadMovementInputsModel, WellheadMovementResponseDto, WellheadType } from '../models/wellhead-movement.model';

const PeriforApiEndpoint = `${environment.PeriforEndpoint}/api`;

// backend returns wellheadType as a numeric enum (0 = Conventional, 1 = MultiBowl)
const WELLHEAD_TYPE_BY_INDEX: WellheadType[] = [WellheadType.Conventional, WellheadType.MultiBowl];

// backend returns hangerLandingSequence as a numeric enum (0 = BeforeCementSet, 1 = AfterCementSet)
const HANGER_LANDING_SEQUENCE_BY_INDEX: HangerLandingSequence[] = [HangerLandingSequence.BeforeCementSet, HangerLandingSequence.AfterCementSet];

@Injectable({
	providedIn: 'root'
})
export class WellheadMovementService {

	constructor(private http: HttpClient) { }

	getWellheadMovement(): Observable<WellheadMovementResponseDto | null> {
		return this.http.get<WellheadMovementResponseDto>(`${PeriforApiEndpoint}/WellheadMovementInputs`)
			.pipe(
				map(response => this.normalizeResponse(response)),
				catchError(() => of(null))
			);
	}

	updateWellheadMovement(data: UpdateWellheadMovementInputsModel): Observable<boolean> {
		return this.http.put<boolean>(`${PeriforApiEndpoint}/WellheadMovementInputs`, data);
	}

	private normalizeResponse(response: WellheadMovementResponseDto): WellheadMovementResponseDto {
		const wellheadType = response.wellhead?.wellheadType;
		const normalizedWellhead = response.wellhead && typeof wellheadType === 'number'
			? { ...response.wellhead, wellheadType: WELLHEAD_TYPE_BY_INDEX[wellheadType] }
			: response.wellhead;

		const normalizedTubularLandings = response.tubularLandings?.map(landing =>
			typeof landing.hangerLandingSequence === 'number'
				? { ...landing, hangerLandingSequence: HANGER_LANDING_SEQUENCE_BY_INDEX[landing.hangerLandingSequence] }
				: landing
		);

		return {
			...response,
			wellhead: normalizedWellhead,
			tubularLandings: normalizedTubularLandings ?? response.tubularLandings
		};
	}
}
